
<ng-container>
	<div class="w-full flex flex-col justify-start items-start">
		<div class="w-full flex flex-row justify-between md:items-center md:pr-4">
			<h3  class="w-full text-2xl mb-4 fb-co-header">
				<span class="material-symbols-outlined">
					quick_reorder
				</span>
				Custom Order Details
			</h3>
		</div>
		<div *ngIf="orderDetails" class="w-full flex flex-col md:flex-row justify-between items-start md:items-center">
			<div class=" flex flex-col md:flex-row gap-2 justify-center items-start">
				<h4>Ordered on <span class="fb-dark-text">{{orderDetails.createdAt | formatDate}}</span></h4>
				<span class="hidden md:block">|</span>
				<h4>Order <span class="fb-dark-text">#{{orderId}}</span></h4>
			</div>
			<div class="flex justify-center items-center md:pr-4 gap-2">
				<h4>TOTAL</h4>
				<div class="fb-dark-text flex gap-1">
					{{orderDetails.currency}}
					{{orderDetails.adjustedTotal | number: '1.0-2'}}
				</div>
			</div>
		</div>
	</div>
	<fb-loader *ngIf="isLoading"></fb-loader>

	<section *ngIf="!isLoading"
			 class="flex flex-col lg:flex-row justify-between items-stretch w-full mt-5  min-h-screen gap-2">
		<div  class="flex flex-col justify-start items-start lg:hidden">
			<div (click)="showOrderInformation = !showOrderInformation"
				 class="w-full flex justify-between items-center gap-2.5 cursor-pointer rounded-md bg-[#FFFAF6] p-4">
				<h4  class="font-medium ">Order Information</h4>

				<span *ngIf="showOrderInformation" class="material-symbols-outlined close">
								arrow_drop_up
							</span>
				<span *ngIf="!showOrderInformation"
					  class="material-symbols-outlined open">
								arrow_drop_down
							</span>
			</div>
			<div class=" fb-faq-body" [ngClass]="showOrderInformation? 'order-active': ''">

				<div class="min-w-[280px] min-h-[150px] px-3 py-5 my-4 rounded-md bg-[#E0DEE4] flex flex-col justify-start items-start gap-2 w-full">
					<h5 class="font-semibold">Order Essentials</h5>
					<div class="w-full text-sm" *ngIf="orderDetails">
						<div class="flex justify-between items-center w-full">
							<span>Shipping Mode: </span>
							<span class=""><span>N/A</span></span>
						</div>

						<div class="flex justify-between items-center w-full">
							<span>Sub Total:</span>
							<span class="text-sm">{{orderDetails.currency}} {{orderDetails.subTotal | number: '1.2-2'}}</span>
						</div>
						<ng-container *ngIf="orderDetails.adjustments && orderDetails.adjustments.length > 0">
							<div *ngFor="let adjustment of orderDetails.adjustments"
								 class="flex justify-between items-center w-full">
								<span>{{adjustment.particular}}: </span>
								<span class="text-sm">
									{{adjustment.adjustmentType === 1? '+': '-'}} {{adjustment.currency}} {{adjustment.adjustmentAmount | number: '1.2-2'}}
								</span>
							</div>
						</ng-container>

						<div class="flex justify-between items-center w-full">
							<span class="font-bold">Total:</span>
							<span class="text-sm">{{orderDetails.currency}} {{orderDetails.adjustedTotal | number: '1.2-2'}}</span>
						</div>
						<div class="text-xs mt-0.5">(Total includes shipping charges)</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="sortOrderSection && sortOrderSection.length > 0"
			 class="gap-3 flex-[100%] flex flex-col justify-between items-start lg:flex-[70%] w-full relative mb-[40px]">
			<ng-container *ngFor="let sortOrder of sortOrderSection">
				<ng-container *ngIf="sortOrder === 'MADE_TO_ORDER'">
					<div *ngIf="madeToOrderItem && madeToOrderItem.length>0"
						 class="w-full flex flex-col justify-start items-start gap-2 rounded-md bg-[#FFFAF6] px-4">
						<div class="w-full flex flex-row justify-between items-start mt-3">
							<h5 class="text-lg ">Made To Order</h5>

							<div class="fb-order-status text-sm md:text-base">
								<p class="dispatch_on"
								   *ngIf="(madeToOrderItem[0].orderStatus==='IN_TRANSIT')">Dispatched</p>
								<p [ngClass]="madeToOrderItem[0].orderStatus"
								   *ngIf="madeToOrderItem[0].orderStatus==='CANCELLED'">Cancelled</p>
								<p [ngClass]="madeToOrderItem[0].orderStatus"
								   *ngIf="madeToOrderItem[0].orderStatus==='INITIATED'">Confirmed</p>
								<p [ngClass]="madeToOrderItem[0].orderStatus"
								   *ngIf="madeToOrderItem[0].orderStatus==='PROCESSING'">Processing</p>
								<p [ngClass]="madeToOrderItem[0].orderStatus"
								   *ngIf="madeToOrderItem[0].orderStatus==='DELIVERED'">Delivered</p>
								<p [ngClass]="madeToOrderItem[0].orderStatus"
								   *ngIf="madeToOrderItem[0].orderStatus==='FAILED'">Failed</p>
							</div>

						</div>
						<div class="w-full flex flex-col md:flex-row justify-between items-start pb-4">
							<div class=" flex flex-col items-start justify-start text-sm">
								<p *ngIf="madeToOrderItem[0].shippingCode">
									Tracking Code: <span class="fb-dark-text">{{madeToOrderItem[0].shippingCode}} </span>
								</p>
								<p *ngIf="madeToOrderItem[0].dispatchedOn">
									Dispatched On: <span class="fb-dark-text">{{madeToOrderItem[0].dispatchedOn | formatDate}}</span>
								</p>
								<p>
									Estimated Delivery: <span class="fb-dark-text">{{madeToOrderItem[0].estimatedDeliveryTo | formatDate}}</span>
								</p>

							</div>
							<a *ngIf="madeToOrderItem[0].trackingUrl"
							   class="rounded-md bg-[#93805e] text-white px-3 py-1.5 mt-3 text-sm"
							   [href]="madeToOrderItem[0].trackingUrl"
							   target="_blank" rel="nofollow">
								<button>Track Order</button>
							</a>

						</div>
						<div class="w-full flex flex-col justify-center items-center gap-6 mb-3">
							<ng-container *ngFor="let product of madeToOrderItem">
								<div class="">
									<fb-custom-order-item [orderItemId]="orderItemId"
															 [orderId]="orderId"
															 [product]="product"></fb-custom-order-item>
								</div>
							</ng-container>
						</div>
					</div>
				</ng-container>
			</ng-container>

			<ng-container *ngIf="orderDetails && orderDetails.note">
				<h5 class="smallheader">Order Note</h5>
				<div class="order_row">
					{{orderDetails.note}}
				</div>
			</ng-container>
		</div>
		<div class="lg:flex-[30%] w-full relative hidden lg:block mx-2">
			<div class="max-w-[280px] min-h-[150px] px-3 py-5 my-4 rounded-md bg-[#E0DEE4] flex flex-col justify-start items-start gap-2 w-full">
				<h5 class="font-semibold">Order Essentials</h5>
				<div class="w-full text-sm" *ngIf="orderDetails">
					<div class="flex justify-between items-center w-full">
						<span>Shipping Mode: </span>
						<span class=""><span>N/A</span></span>
					</div>

					<div class="flex justify-between items-center w-full">
						<span>Sub Total:</span>
						<span class="text-sm">{{orderDetails.currency}} {{orderDetails.subTotal | number: '1.2-2'}}</span>
					</div>
					<ng-container *ngIf="orderDetails.adjustments && orderDetails.adjustments.length > 0">
						<div *ngFor="let adjustment of orderDetails.adjustments"
							 class="flex justify-between items-center w-full">
							<span>{{adjustment.particular}}: </span>
							<span class="text-sm">
									{{adjustment.adjustmentType === 1? '+': '-'}} {{adjustment.currency}} {{adjustment.adjustmentAmount | number: '1.2-2'}}
								</span>
						</div>
					</ng-container>

					<div class="flex justify-between items-center w-full">
						<span class="font-bold">Total:</span>
						<span class="text-sm">{{orderDetails.currency}} {{orderDetails.adjustedTotal | number: '1.2-2'}}</span>
					</div>
					<div class="text-xs mt-0.5">(Total includes shipping charges)</div>
				</div>
			</div>

		</div>
	</section>
	<ng-container>
	</ng-container>

</ng-container>
